module.exports = "/images/red-bg.png?37fd3d2beb688bbcddadb34d1228455e";


//////////////////
// WEBPACK FOOTER
// ./resources/images/expirePop/red-bg.png
// module id = zHUF
// module chunks = 183